import { useField } from 'react-final-form';

import { IKnmForm } from '../../../KnmPackage/MainModule/interfaces/IKnmForm';
import { ErknmApproveRemarkSectionCodeEnum } from '../../ErknmApproveRemarkModule/enums/ErknmApproveRemarkSectionCodeEnum';

export const useHasFieldApproveRemark = (sectionCode: ErknmApproveRemarkSectionCodeEnum) => {
  const approveRemarks: IKnmForm['approveRemarks'] = useField('approveRemarks' as keyof IKnmForm, {
    subscription: { value: true },
  }).input.value;

  return Array.isArray(approveRemarks) && !!approveRemarks?.find(item => item.sectionCode === sectionCode);
};
